'use client';

import Link from 'next/link';
import { Breadcrumb } from '@baseline/ui';
import type { ResourcesBreadcrumbProps } from './types';

const ResourcesBreadcrumb = ({
  category,
  categoryHref,
  itemClassName
}: ResourcesBreadcrumbProps) => {
  return (
    <Breadcrumb
      items={[
        { label: 'RESOURCES', href: '/resources' },
        { label: category, href: categoryHref }
      ]}
      itemClassName={itemClassName}
      renderLinkComponent={({ className, href, label }) => (
        <Link href={href} className={className}>
          {label}
        </Link>
      )}
    />
  );
};

export default ResourcesBreadcrumb;
